import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
* 异步树加载组件 通过传入表名 显示字段 存储字段 加载一个树控件
* <j-tree-select dict="aa_tree_test,aad,id" pid-field="pid" ></j-tree-select>
* */
import { getAction } from '@/api/manage';
export default {
  name: 'JTreeSelect',
  props: {
    value: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: '请选择',
      required: false
    },
    dict: {
      type: String,
      default: '',
      required: false
    },
    pidField: {
      type: String,
      default: 'pid',
      required: false
    },
    pidValue: {
      type: String,
      default: '0',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    hasChildField: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {
      treeValue: "",
      treeData: [],
      url: "/sys/dict/loadTreeData",
      view: '/sys/dict/loadDictItem/',
      tableName: "",
      text: "",
      code: ""
    };
  },
  watch: {
    value: function value() {
      this.loadItemByCode();
    },
    dict: function dict() {
      this.initDictInfo();
      this.loadRoot();
    }
  },
  created: function created() {
    this.initDictInfo();
    this.loadRoot();
    this.loadItemByCode();
  },
  methods: {
    loadItemByCode: function loadItemByCode() {
      var _this = this;

      if (!this.value || this.value == "0") {
        this.treeValue = "";
      } else {
        getAction("".concat(this.view).concat(this.dict), {
          key: this.value
        }).then(function (res) {
          if (res.success) {
            _this.treeValue = {
              key: _this.value,
              value: _this.value,
              label: res.result
            };
          }
        });
      }
    },
    initDictInfo: function initDictInfo() {
      var arr = this.dict.split(",");
      this.tableName = arr[0];
      this.text = arr[1];
      this.code = arr[2];
    },
    asyncLoadTreeData: function asyncLoadTreeData(treeNode) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (treeNode.$vnode.children) {
          resolve();
          return;
        }

        var pid = treeNode.$vnode.key;
        var param = {
          pid: pid,
          tableName: _this2.tableName,
          text: _this2.text,
          code: _this2.code,
          pidField: _this2.pidField,
          hasChildField: _this2.hasChildField
        };
        getAction(_this2.url, param).then(function (res) {
          if (res.success) {
            var _iterator = _createForOfIteratorHelper(res.result),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var i = _step.value;
                i.value = i.key;

                if (i.leaf == false) {
                  i.isLeaf = false;
                } else if (i.leaf == true) {
                  i.isLeaf = true;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _this2.addChildren(pid, res.result, _this2.treeData);

            _this2.treeData = _toConsumableArray(_this2.treeData);
          }

          resolve();
        });
      });
    },
    addChildren: function addChildren(pid, children, treeArray) {
      if (treeArray && treeArray.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(treeArray),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;

            if (item.key == pid) {
              if (!children || children.length == 0) {
                item.isLeaf = true;
              } else {
                item.children = children;
              }

              break;
            } else {
              this.addChildren(pid, children, item.children);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    },
    loadRoot: function loadRoot() {
      var _this3 = this;

      var param = {
        pid: this.pidValue,
        tableName: this.tableName,
        text: this.text,
        code: this.code,
        pidField: this.pidField,
        hasChildField: this.hasChildField
      };
      getAction(this.url, param).then(function (res) {
        if (res.success && res.result) {
          var _iterator3 = _createForOfIteratorHelper(res.result),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var i = _step3.value;
              i.value = i.key;

              if (i.leaf == false) {
                i.isLeaf = false;
              } else if (i.leaf == true) {
                i.isLeaf = true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          _this3.treeData = _toConsumableArray(res.result);
        } else {
          console.log("数根节点查询结果-else", res);
        }
      });
    },
    onChange: function onChange(value) {
      if (!value) {
        this.$emit('change', '');
        this.treeValue = '';
      } else {
        this.$emit('change', value.value);
        this.treeValue = value;
      }
    },
    onSearch: function onSearch(value) {
      console.log(value);
    },
    getCurrTreeData: function getCurrTreeData() {
      return this.treeData;
    }
  },
  //2.2新增 在组件内定义 指定父组件调用时候的传值属性和事件类型 这个牛逼
  model: {
    prop: 'value',
    event: 'change'
  }
};